
<div class="admin">
	<header>
		<div class="logo"></div>
	</header>
	<router-outlet></router-outlet>
</div>

<!-- Shared by every confirmation in the admin. Without a width it grows to fit the message on one line. -->
<p-confirmDialog [style]="{ width: '480px', maxWidth: '90vw' }" />